var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMercedes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 142.3 142.3",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.6,70.8 75.7,68.9 115.3,96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.3,69.3 67.4,67.6 70.7,15.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.8,69.1 53.7,80 69.4,70.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,0.6c-39,0-70.6,31.6-70.6,70.6s31.6,70.6,70.6,70.6c39,0,70.6-31.6,70.6-70.6C141.7,32.2,110.1,0.6,71.1,0.6 L71.1,0.6z M71.1,137.9c-16.1,0-31.2-5.4-42.5-15.2C17.7,113.1,9.2,97.8,7.1,81.6c5,30.9,31.7,54.4,64,54.4 c35.8,0,64.8-29,64.8-64.8c0-14.9-5.5-29.4-14-40.3c8.5,6.6,15.9,25.3,15.9,40.3C137.9,108.1,108,137.9,71.1,137.9L71.1,137.9z  M65,66.1l5.7-58.5c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0l0.6,61.6l9.8-5.9L71.8,7.6c34.8,0.3,62.9,28.7,62.9,63.5 c0,11.2-2.9,21.7-8,30.9L82.6,65.1l-4.2,2.4l48,35.1c-0.1,0.2-0.2,0.4-0.4,0.6L72,72.1v10.9l53.6,20.7 c-11.1,18.5-31.4,30.9-54.5,30.9c-23.1,0-43.4-12.4-54.5-30.8L70.2,83V72l-54,31c-0.1-0.2-0.2-0.4-0.4-0.6l47.8-35l-4.2-2.4 l-44,36.7c-5-9.1-7.9-19.5-7.9-30.7c0-34.6,27.7-62.7,62.1-63.5L61,63.8L65,66.1L65,66.1z M71.1,4.4C34.3,4.4,4.4,34.3,4.4,71.1 c0,15,5.4,29.1,13.7,41.4c2.8,5.3,5.8,8.5,9.9,12.8C12.1,112.6,1.8,93,1.8,71.1c0-38.3,31-69.3,69.3-69.3s69.9,32.4,68.7,69.3 C138.9,35.1,107.4,4.4,71.1,4.4L71.1,4.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercedes);
export default __webpack_public_path__ + "static/media/Mercedes.42ecc869026799253bf8d196c36bfc09.svg";
export { ForwardRef as ReactComponent };